import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
  CircularProgress
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { DeedTypography, ColorPaper } from '../Atoms'
import { MainPageContainer } from '../Organisms'
import { SearchService } from '../../services'
import { useAsyncError } from '../../utils/Error'


const useStyles = makeStyles(theme => ({
  document: {
    // 595pr = typical deed width
    // 2rem = 2 times 1 rem padding on the sides
    // 2px = 2 times 1px for the border
    width: "calc(595pt + 2rem + 2px)",
  },
}))


function Document({ match: { params: { deedId } } }) {
  const classes = useStyles()
  const { i18n } = useTranslation()
  const [deed, setDeed] = React.useState(null)
  const throwError = useAsyncError()

  React.useEffect(() => {
    let isSubscribed = true
    SearchService.getDeedById(deedId)
      .then(json => {
        if (isSubscribed) setDeed(json)
      })
      .catch(error => {
        throwError({
          title: "Failed to get document",
          detail: JSON.stringify(error.detail),
        })
      })
    return () => isSubscribed = false
  }, [deedId, throwError, i18n.language])

  const renderClause = ({ html, text, clause_id }) => {
    if (html) return <div key={clause_id} dangerouslySetInnerHTML={{
      __html: html
    }} />
    else return <DeedTypography key={clause_id}>{text.join(" ")}</DeedTypography>
  }

  if (!deed) return <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  }}>
    <CircularProgress />
  </div>

  return (
    <MainPageContainer>
      <ColorPaper className={classes.document}>
        {deed.documents.map(renderClause)}
      </ColorPaper>
    </MainPageContainer>
  )
}

export default Document
